export default {
    data() {
        return { window: window }
    },
    computed: {
        itsWebVersion: function () {
           return typeof window !== 'undefined' && typeof document !== 'undefined'
        }
    },
}